import { createSlice } from '@reduxjs/toolkit';

export const IMAGE_ENHANCER_USE_CREDIT = 2;

export const FJSliceImageEnhancer = createSlice({
    name: 'imageEnhancer',
    initialState: {
        isDone: false,
        uploadImageList: [],
        upscale: 2,
        selectCreationId: '',
        imageEnhancerCreationList: [],
    },
    reducers: {
        setSliceUploadImageListAction: (state, action) => {
            state.uploadImageList = action.payload;
        },
        setSliceZoomAction: (state, action) => {
            state.upscale = action.payload;
        },
        setSliceSelectCreationIdAction: (state, action) => {
            state.selectCreationId = action.payload;
        },
        setSliceImageEnhancerCreationListAction: (state, action) => {
            const isLoading = action.payload.filter(i => i.isLoading).length !== 0;
            state.imageEnhancerCreationList = action.payload;
            state.isDone = action.payload.length > 0 && !isLoading;
        },
    },
});

export const {
    setSliceUploadImageListAction,
    setSliceZoomAction,
    setSliceSelectCreationIdAction,
    setSliceImageEnhancerCreationListAction,
} = FJSliceImageEnhancer.actions;

export default FJSliceImageEnhancer.reducer;
